// extracted by mini-css-extract-plugin
export var bottomRightDock = "_4v-0";